import * as React from 'react'
function SvgTrash(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M32 16v16c0 2.2-1.8 4-4 4H12c-2.2 0-4-1.8-4-4V16h24zM26 4c1.2 0 2 .8 2 2v4h6a2 2 0 110 4H6a2 2 0 110-4h6V6c0-1.2.8-2 2-2zm-2 4h-8v2h8V8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgTrash
